<template>
  <div class="wg-row event-cover">
    <img :src="$anm22.icons.getWorldIcon('photoCamera')" class="label-ic" />
    <input
      :disabled="!editMode"
      type="text"
      v-model="cover"
      @change="save"
      :placeholder="
        $anm22.strLang(
          lang,
          'Add cover image URL',
          'Aggiungi URL immagine cover'
        )
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    event: {
      type: Object,
      default: null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cover:
        this.event.jsonData && this.event.jsonData.cover
          ? this.event.jsonData.cover
          : "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
  },
  methods: {
    save() {
      this.$emit("updateEventDataProperty", "cover", this.cover, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.event-cover {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);

  .label-ic {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  input {
    flex: 1;
    max-width: unset;
  }
}
</style>
